import { Button, ClickAwayListener, Tooltip, Link } from "@mui/material";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CONTACT_EMAIL } from "../constants";

const styles = {
  button: {
    "&:hover, &": {
      background: "#283033",
    },
  },
};

const ContactButton = ({ className, renderLink, children, ...rest }) => {
  const { t } = useTranslation();
  const [openTooltip, setOpenTooltip] = useState(false);

  const handleTextCopy = () => {
    navigator.clipboard.writeText(CONTACT_EMAIL).then(handleTooltipOpen);
  };

  const handleTooltipOpen = () => {
    setOpenTooltip(true);

    setTimeout(handleTooltipClose, 5000);
  };

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };

  const linkProps = {
    href: `mailto:${CONTACT_EMAIL}`,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleTextCopy,
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        title={<h2>{t("email-copy-feedback")}</h2>}
        open={openTooltip}
        arrow
      >
        {renderLink ? (
          <Link className={className} underline="none" {...linkProps}>
            {children || t("contactUs")}
          </Link>
        ) : (
          <Button
            className={className}
            variant="contained"
            sx={styles.button}
            {...linkProps}
            {...rest}
          >
            {children || t("contactUs")}
          </Button>
        )}
      </Tooltip>
    </ClickAwayListener>
  );
};

export default ContactButton;
